module.exports = __webpack_public_path__ + "static/media/Jim Gray.cfc151fe.png";